/** @format */
import type {MouseEvent} from 'react';

import {Root} from './styles';

interface Props {
  color: string;
  onCrSettingsClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
}

const CrSettingsButton = ({color, onCrSettingsClick, disabled}: Props) => {
  return (
    <Root customColor={color} onClick={onCrSettingsClick} disabled={disabled}>
      Выбрать показатели
    </Root>
  );
};

export {CrSettingsButton};
